import { IFormConfig } from 'reactcomponents/interfaces/FormConfig';
import { KenticoFormViewmodel } from '../interfaces/PageInterfaces';

export const  CreateFormViewModel = (FormDefinition, FormName, FormType, LinkToEditPage, Title: string, formConfig? : IFormConfig) : KenticoFormViewmodel => {
  return {
    
      FormDefinition : FormDefinition,
      
      FormConfig: formConfig,

      withLinkToFormPage : true,

      FormName: FormName,
      FormType: FormType,
      EditMode: false,
      editMode: false,
      WithLinkToFormPage: true,
      noAutoGenerateSummary: true,
      NextLink: LinkToEditPage,
      LinkText : "Aanpassen",
      DocumentID : "",
      ClassName : "",

      SummaryIntro : "",
      OnSuccessPopupMessage : "",
      OnSuccessPopupMessageVisualCheck: "",
      OnSuccessPopupDescription: "",
      IncludeCurrentPageAsBackAndSubmitUrl: true,
      backTitleForCurrentPageBackLink : Title,
      RestApiEndpoint : "",
      EditPageLink : "",
      OnSubmitSuccessLink : "",
      OnSubmitFailureLink : "",

      OnSubmitSuccessButton1Link: "",
      OnSubmitSuccessButton1LinkText: "",
      OnSubmitSuccessButton2Link: "",
      OnSubmitSuccessButton2LinkText: "",
      MijnFnvFormLinks: [],

      ErrorMessageTitle : "",
      ErrorMessageDescription : "",
      ErrorMessagePhoneNumberInfo : "",
      ErrorMessagePhoneNumber : "",
      ErrorMessageEmailInfo : "",
      ErrorMessageEmail : "",
      ErrorMessageButtonText : ""
  };
};
